export default function AboutHero() {
  return (
    <section className="pt-32 pb-16 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <h1 className="font-sora font-bold text-6xl text-charcoal mb-6">
          About LaCrue Digital
        </h1>
        <p className="font-inter text-xl text-gray-600 leading-relaxed">
          Building premium websites and helping local businesses grow online.
        </p>
      </div>
    </section>
  );
}